// src/hooks/useOtaUpdate.js
// Over-the-air web updates: on native launch we notify the updater the app is
// healthy (so it won't roll back), then check the admin-published web bundle. If
// it's newer than what's running, download it and apply on the NEXT launch —
// seamless, no reinstall. Native code changes still need a new APK.
import { useEffect } from 'react';
import { isNativeApp } from '../utils/platform';
import { getPlatformSettings } from '../utils/api';

function cmpVer(a, b) {
  const pa = String(a).split('.').map(n => parseInt(n, 10) || 0);
  const pb = String(b).split('.').map(n => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0 ? 1 : -1;
  }
  return 0;
}

export function useOtaUpdate() {
  useEffect(() => {
    if (!isNativeApp()) return;
    (async () => {
      try {
        const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
        // Confirm this bundle booted OK (prevents auto-rollback).
        await CapacitorUpdater.notifyAppReady();

        const s = await getPlatformSettings();
        if (!s?.webBundleUrl || !s?.webBundleVersion) return;

        let curVer = '0.0.0';
        try { const c = await CapacitorUpdater.current(); curVer = c?.bundle?.version || curVer; } catch {}
        if (cmpVer(s.webBundleVersion, curVer) <= 0) return;

        const bundle = await CapacitorUpdater.download({ url: s.webBundleUrl, version: String(s.webBundleVersion) });
        // Apply on next app start so we never interrupt the current session.
        await CapacitorUpdater.next({ id: bundle.id });
      } catch { /* offline / plugin absent — ignore */ }
    })();
  }, []);
}
